<script setup>
import {useRoute} from "vue2-helpers/vue-router";
import needsService from "@/services/needs.service";
import {ref, onMounted} from "vue";

const route = useRoute();
const need = ref(null);
const startups = ref([]);

onMounted(() => {
    getInfo();
    getStartups();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);
    need.value = data;
}

async function getStartups() {
    const {data} = await needsService.getStartups(route.params.id);
    startups.value = data;
}

async function getNewAiMatches() {
    await needsService.getNewAiMatches(route.params.id);
    await getStartups();
}
</script>

<template>
    <div v-if="need" class="need-page">
        <div class="card-needs">
            <div class="card-needs__content card-needs__content--columns">
                <div>
                    <h5 class="heading5 heading5--secondary">{{need.name}}</h5>
                    <p>{{need.description}}</p>

                    <div class="btn-xl-wrapper">
                        <a href="#" class="btn-xl btn-xl-bordered btn-xl-edit">Refine Need</a>
                        <a href="#" class="btn-xl btn-xl-export">Escalate Need</a>
                    </div>
                </div>

                <div class="card-needs__sidebar">
                    <ul class="list-plan">
                        <li class="list-plan__done">Add AI-suggested solutions</li>
                        <li class="list-plan__done">Add ecosystem recommendations</li>
                        <li>Rate all your solutions</li>
                        <li>Escalate need to innovation team</li>
                    </ul>
                </div>
            </div>
            <footer class="card-needs__footer">
                <p><b>Escalate</b> to send this need and your assessed solutions to your innovation team for further review</p>
            </footer>
        </div>

        <div class="need-page__content">
            <aside class="need-page__aside">
                <div class="card-headline">
                    <header class="card-headline__header">Summary Report</header>

                    <div class="card-headline__inner">
                        <img src="https://sp-images-prod.s3.amazonaws.com/knowledge-base-images/image%286%29.png" alt="" />
                    </div>
                    <footer class="card-headline__footer">
                        <a href="#" class="link link--view d-flex justify-content-end">View</a>
                    </footer>
                </div>

                <div class="card-headline">
                    <header class="card-headline__header">Activity</header>

                    <div class="card-headline__content">
                        <ul class="need-list-activity">
                            <li><span>Disliked <a href="#">Eta Foods</a></span></li>
                            <li class="need-list-activity__like"><span>Liked <a href="#">Gamma Core</a></span></li>
                            <li><span>Removed <a href="#">Gamma Core</a></span></li>
                            <li><span>Disliked <a href="#">Eta Foods</a></span></li>
                            <li class="need-list-activity__like"><span>Liked <a href="#">Gamma Core</a></span></li>
                        </ul>

                        <div class="text-center">
                            <a href="#" class="link">Load More</a>
                        </div>
                    </div>
                </div>

                <div class="card-headline">
                    <header class="card-headline__header">Settings</header>

                    <div class="card-headline__content">
                        

                        <div class="content-switcher content-switcher--tertiary">
                            AI solution recommendations
                            <div class="content-switcher__slider">
                                <input type="checkbox" id="hidden-for-startups-switcher__slider">
                                <label for="hidden-for-startups-switcher__slider"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            <div>
                <div class="card card--shadow">
                    asd
                </div>
            </div>
        </div>
        
        <div>
            Startups:
            <div v-for="startup in startups" :key="startup.id">
                {{startup.name}}
            </div>
        </div>

        <a class="link" @click="getNewAiMatches">Get New Matches</a>
    </div>
</template>

<style scoped>

</style>
